module.exports = __webpack_public_path__ + "static/media/roboto-v20-latin-300.b00849e0.woff";